// language=GraphQL
export const ALL_SOCIAL_MEDIA_SETTINGS_QUERY = `query Query {
  socialMediaSettings: allCmsSocialMediaSettings {
    id
    facebookUrl
    instagramUrl
  }
}`

// language=GraphQL
export const SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY = `query Query($id: ID!) {
  socialMediaSettings: cmsSocialMediaSettings(id: $id) {
    id
    facebookUrl
    instagramUrl
  }
}`

// language=GraphQL
export const CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateCmsSocialMediaSettingsInput) {
    socialMediaSettings: createCmsSocialMediaSettings(input: $input) {
      id
      facebookUrl
      instagramUrl
    }
  }`

// language=GraphQL
export const UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateCmsSocialMediaSettingsInput) {
    socialMediaSettings: updateCmsSocialMediaSettings(input: $input) {
      id
      facebookUrl
      instagramUrl
    }
  }`

// language=GraphQL
export const DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteCmsSocialMediaSettingsInput) {
    deleteCmsSocialMediaSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteCmsSocialMediaSettingsInput) {
    forceDeleteCmsSocialMediaSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const SOCIAL_MEDIA_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsConfigs: Boolean = false) {
  groupedDependents: cmsSocialMediaSettingsDependents(id: $id) {
    cmsConfigs @include(if: $withCmsConfigs) {
      id
    }
  }
}`
